
// Get URL parameters
export const queryString = () => {
    let _queryString = {};
    const _query = window.location.search.substr(1);
    const _vars = _query.split('&');
    _vars.forEach((v, i) => {
        const _pair = v.split('=');
        if (!_queryString.hasOwnProperty(_pair[0])) {
            _queryString[_pair[0]] = decodeURIComponent(_pair[1]);
        } else if (typeof _queryString[_pair[0]] === 'string') {
            const _arr = [_queryString[_pair[0]], decodeURIComponent(_pair[1])];
            _queryString[_pair[0]] = _arr;
        } else {
            _queryString[_pair[0]].push(decodeURIComponent(_pair[1]));
        }
    });
    return _queryString;
};

// Remove specified element from array
Array.prototype.remove = function (val) {
    var index = this.indexOf(val);
    if (index > -1) {
        this.splice(index, 1);
    }
};

// Date extension (format validation)
Date.prototype.Format = function (fmt) {
    var o = {
    "M+": this.getMonth() + 1, //Month
    "d+": this.getDate(), //Day
    "h+": this.getHours(), //Hour
    "m+": this.getMinutes(), //Minute
    "s+": this.getSeconds(), //Second
    "q+": Math.floor((this.getMonth() + 3) / 3), //Quarter
    "S": this.getMilliseconds() //Millisecond
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 -
        RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ?
            (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

export const convertUTCDateToLocalDate = (UTCDateString) => {
    if (!UTCDateString) { return null }
    // UTCDateString is the time to be converted (Date type)
    // Get timezone
    var i = new Date().getTimezoneOffset() / 60
    if (typeof i !== 'number') return;
    var len = new Date(Date.parse(UTCDateString.replace(/-/g, "/"))).getTime();
    // Get current Greenwich time
    var LocalDate = len - 3600000 * i;
    return new Date(LocalDate).Format("yyyy-MM-dd hh:mm:ss")
}

export const convertLocalDateToUTCDate = (UTCDateString) => {
    if (!UTCDateString) { return null }
    // UTCDateString is the time to be converted (Date type)
    // Get timezone
    var i = new Date().getTimezoneOffset() / 60
    if (typeof i !== 'number') return;
    var len = new Date(Date.parse(UTCDateString.replace(/-/g, "/"))).getTime();
    // Get current Greenwich time
    var LocalDate = len + 3600000 * i;
    return new Date(LocalDate).Format("yyyy-MM-dd hh:mm:ss")
}

export const isObjectValueEqual = (a, b) => {
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length != bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i]

        var propA = a[propName]
        var propB = b[propName]
        if ((typeof (propA) === 'object')) {
            if (this.isObjectValueEqual(propA, propB)) {
                return true
            } else {
                return false
            }
        } else if (propA !== propB) {
            return false
        } else { }
    }
    return true
}




/**
 * Function brief description
 *  dataSelete (Array):
 *  [{
 *      key: "5d6b58ece6f19d11ca5ce734",
 *      UserName: "",
 *      Email: "jy13@getnada.com",
 *      ActivationStatus: "0/1",
 *      AssignedTime: "2019-09-01 13:36:44"
 *  }]
 *
 *  columns  (Array):
 *  ["UserName", "Email", "ActivationStatus", "AssignedTime"]
 *
 *  Will filter out items not in columns
 */
export function exportUser(dataSelete, columns, callback) {
    console.info("exportUser :", dataSelete, columns, !!callback)
    // Column titles, separated by commas; each comma separates a cell
    let str = `${columns.join(",")}\n`;
    // Add \t to prevent scientific notation or other formats in the table
    dataSelete.map((data, index) => {
        for (let item in data) {
            if (columns.indexOf(item) != -1) {
                str += `${data[item] + '\t'},`;
            }
        }
        str += '\n';
    });

    // Use encodeURIComponent to fix Chinese character encoding issues
    let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str);
    // Create an <a> tag to trigger download
    let link = document.createElement("a");
    link.href = uri;
    // Name the downloaded file
    link.download = new Date().toISOString().substring(0, 10) + "-License.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => {
        callback && callback()
    }, 1000);
}

// Convert image URL to base64
export function getUrl_Base64(url, callback) {
    // Create img instance via constructor; assigning src downloads image immediately. Compared to createElement(), avoids append() and document pollution.
    let Img = new Image(),
      dataURL = '';
    Img.src = url +"?v=" + Math.random(); // Fix cache bug; browser may error if cached
    Img.setAttribute("crossOrigin", 'Anonymous') // Fix cross-origin error in console
    Img.onload = function () { // Ensure image is fully loaded (async event)
    let canvas = document.createElement("canvas"), // Create canvas element
          width = Img.width, // Ensure canvas size matches image
          height = Img.height;
        canvas.width = width;
        canvas.height = height;
    canvas.getContext("2d").drawImage(Img, 0, 0, width, height); // Draw image onto canvas
    dataURL = canvas.toDataURL('image/jpeg'); // Convert image to dataURL
        callback && callback(dataURL)
    };
}


// Wrapper for window open
export function windowActionFn(_window, fnName, args) {
    if (!_window && typeof _window[fnName] !== 'function') return;
    return _window[fnName](...args);
}

// Wrapper for storage get
export function storageGetItem(storage, key) {
    if (!storage) return null;
    return storage.getItem(key);
}

// Wrapper for storage remove

export function storageRemoveItem(storage, key) {
    if (!storage) return null;
    return storage.removeItem(key);
}
// Wrapper for storage clear
export function storageClear(storage) {
    storage && storage.clear();
}

// Write to storage
export function storageSetItem(storage, key, value) {
    storage && key && storage.setItem(key, value);
}

// Array deduplication (strict equality)
export function unique(arr) {
    return arr.filter((item, index, arr) => {
        return arr.indexOf(item, 0) === index;
    })
}